module.exports = __webpack_public_path__ + "images/banner2.1460.png";